<template>
  <div>
    <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo elementos creados
      </span>
      <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span>
      <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
        <!--<input type="date" class="fecha" v-model="periodoDesde">-->
        <datetime
          data-cy="start-time"
          v-model="rangeFrom"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar',
          cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
        />
        y el
        <datetime
          data-cy="end-time"
          v-model="rangeUntil"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
        />
        <span>
          <vs-button
            radius
            data-cy="filter-by-date"
            class="ml-3 d-inline"
            color="primary"
            type="border"
            icon="search"
            size="small"
            @click="changeFilters(currentFilters)"
          />
        </span>
      </span>
      <vs-dropdown data-cy="change-date" vs-trigger-click style="margin-left: 15px">
        <a class="a-icon" href="#">
          Cambiar
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-dropdown-item
            style="width:200px"
            v-for="range in ranges"
            :key="range.valor"
            v-on:click="selectRange(range)"
            data-cy="change-date-item"
          >
            {{ range.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <FiltersAduanas
      data-cy="filter-by-date"
      :filtersView="filterView"
      :users="usersCompany"
      :groups="lotteryCustoms"
      :legalQualities="legalQualities"
      :periodos="ranges"
      :has-query-filters="!!queryFilters"
      :clear-query-filters="clear"
      v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltersAduanas from '@/febos/global/_vue/componentes/filtersLetty/aduanas/FiltersAduanas';
import ConfigReceiptsFiltersMixin from '@/febos/global/_vue/componentes/filtersLetty/aduanas/ConfigReceiptsFiltersMixin';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { DATE_RANGE_LAST_6_MONTH, DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import { ioGetHoldingGroupsCompanies } from '@/febos/servicios/api/v2.companies.api';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';

export default {
  components: { FiltersAduanas },
  props: ['value', 'onChange', 'clear', 'defaultDate', 'isHistory'],
  mixins: [ConfigReceiptsFiltersMixin, SelectorDateMixin],
  data() {
    const { name } = this.$route;
    const range = this.defaultDate ? this.defaultDate : DATE_RANGE_LAST_6_MONTH;
    return {
      lotteryCustoms: [],
      legalQualities: [],
      ranges: DATE_RANGES,
      rangeSelected: range,
      rangeFrom: '',
      rangeUntil: '',
      view: name,
      currentFilters: '',
      queryFilters: this.$route.query.filters
    };
  },
  async created() {
    this.selectRange(this.rangeSelected, true);
    await this.loadCompanyData();
  },
  watch: {
    'company.id'(newId, oldId) {
      if (newId && newId !== oldId) {
        this.loadCompanyData();
      }
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany',
      'groupsCompany'
    ]),
    configuration() {
      return this.getFilterView(this.view);
    },
    filterView() {
      return this.getFilterView(this.view);
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getGroupsCompany'
    ]),
    async loadCompanyData() {
      this.getUsersCompany({
        empresaId: this.company.id,
        pagina: 1,
        filas: 10000,
        // buscarInfoExtra: 'si',
        // filtroInfoExtra: 'CARGO'
      });
      this.getGroupsCompany({ empresaId: this.company.id });
      const qualities = await listOptions({
        grupoOpcion: 'calidad-juridica-aduanas',
        deshabilitado: 'no'
      });
      this.legalQualities = qualities.data.opciones
        .map((element) => ({
          id: element.opcionId,
          value: element.valor,
          label: element.descripcion,
          extra: JSON.parse(element.extra)
        }));
      const holdingGroups = await ioGetHoldingGroupsCompanies({
        empresaId: this.company.id
      });
      this.lotteryCustoms = holdingGroups.data.grupos;
    },
    async changeFilters(filters, onMounted) {
      const rangeFrom = this.$moment(this.rangeFrom).format('YYYY-MM-DD');
      const rangeUntil = this.$moment(this.rangeUntil).format('YYYY-MM-DD');
      const defaultFilters = `${this.isHistory ? 'lote.' : ''}fechaCreacion:${rangeFrom}--${rangeUntil}`;
      this.currentFilters = filters;
      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;

      if (!onMounted) {
        const nonShareableFilters = [
          // TODO: agregar campo de busqueda de coincidencias
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}
.search-bar {
  align-items: baseline;
  width: 50%;
}
</style>
